import { ValidationsRegex as _ValidationsRegex } from 'ui/utils/validations/validations';

// TODO: remove this and use ValidationsRegex from ui/utils
export const ValidationsRegex = {
  Password: _ValidationsRegex.Password,
  JustLettersNumbersHyphen: /^[A-Za-z0-9-]+$/u,
};
